import * as THEOS from "../interfaces/theos.interface";
import { IApiConfig, IModuleConfig } from "./types";
import { LogLevel, error, log, setLogLevel } from "../utils/log";
import { LegacyApiAdapter } from "../modules/LegacyApiAdapter";
import { RgPostMessageApiAdapter } from "../modules/RgPostMessageApiAdapter";
import { addSupportedApi } from "./messageProcessor";
import { sendGameEvent } from "./sendGameEvent";

/**
 * @internal
 */
export const _configuration: IApiConfig = {};

/**
 * @internal
 * Sends some configuration data to the possible Theos layer
 */
const configureApi = (newConfig: IModuleConfig): void =>
{
    log("Assigning config:", LogLevel.INIT, Object.keys(newConfig));
    log("Config content:", LogLevel.ALL_MESSAGES_AND_PAYLOADS, newConfig);

    try {
        if (newConfig.loginResponse?.stats.currency !== undefined)
        {
            const configureData: THEOS.IConfigData = { currencyCode: newConfig.loginResponse.stats.currency };
            sendGameEvent(THEOS.GameEvent.CONFIGURE, configureData);
        }
    } catch (e) {
        error("Invalid login response");
    }

    if (newConfig.p2pConfig !== undefined) {
        const configureData: THEOS.IConfigData = { currencyCode: newConfig.p2pConfig.currency };
        sendGameEvent(THEOS.GameEvent.CONFIGURE, configureData);
    }

    if (newConfig.handleFeaturePause) {
        sendGameEvent(THEOS.GameEvent.CONFIGURE, { handleFeaturePause: newConfig.handleFeaturePause });
    }

    Object.assign(_configuration, newConfig);
};

let apisChecked = false;

/**
 * Configures the module.
 *
 * Can be called multiple times, new configuration is merged into the existing one.
 *
 * @param config - An object containing the configuration changes
 */
export const configure = (config: IModuleConfig): void =>
{
    setLogLevel(config.logLevel);

    if (!apisChecked && config.handleRgPostMessageAPI === true) {
        apisChecked = true;
        addSupportedApi(new RgPostMessageApiAdapter());
        addSupportedApi(new LegacyApiAdapter());
    }

    configureApi(config);
};

/**
 * Get the current configuration
 * @returns Active configuration, a combination of what the game has sent with [[configure]] and what the operator
 * environment supports.
 */
export const getConfiguration = (): IApiConfig =>
{
    return _configuration;
};
